import React, { PropsWithChildren } from 'react';

export type NamelessAccountContextProps = {
  shouldRegisterOnEmailSubmit: boolean;
  onPasswordFormLoad?: () => void;
  onAccountUpdate?: (name: string, phone?: string) => void;
  emailRegistrationError?: string;
};

export const NamelessAccountContext = React.createContext<NamelessAccountContextProps>(
  // Default values for context
  {
    shouldRegisterOnEmailSubmit: false,
    onPasswordFormLoad: undefined,
    onAccountUpdate: undefined,
    emailRegistrationError: '',
  },
);

export const NamelessAccountContextProvider: React.FC<
  PropsWithChildren<NamelessAccountContextProps>
> = ({
  shouldRegisterOnEmailSubmit,
  onPasswordFormLoad,
  onAccountUpdate,
  emailRegistrationError,
  children,
}) => {
  return (
    <NamelessAccountContext.Provider
      value={{
        shouldRegisterOnEmailSubmit,
        onPasswordFormLoad,
        onAccountUpdate,
        emailRegistrationError,
      }}
    >
      {children}
    </NamelessAccountContext.Provider>
  );
};
